$(function() {
    $(document).ready(function(){
        $(".js-menu-scroll").on("click","a", function (event) {
            event.preventDefault();
            if ($('.js-menu-item').hasClass('nav__link_active')) {
                $('.js-menu-item').removeClass('nav__link_active')
            }
            $(this).addClass('nav__link_active');
            var id  = $(this).attr('href'),
                top = $(id).offset().top;
            $('body,html').animate({scrollTop: top}, 1000);
        });
    });
})
